import { render, staticRenderFns } from "./RegisterPrimaryPhoneNumber.vue?vue&type=template&id=517d49e5&"
import script from "./RegisterPrimaryPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./RegisterPrimaryPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPrimaryPhoneNumber.vue?vue&type=style&index=0&id=517d49e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports